import { useTheme } from '@mui/material';
import { AuthenticatedLink } from '../../components/atoms/AuthenticatedLink';
import { getConfig } from '../../providers/ConfigProvider';
import { DocumentDto } from './models/ClientEntityDto';
import { useStyles } from './style';
import {
  Table,
  Icons,
  GridRowsProp,
  GridRowParams,
  TypeSafeColDef,
} from '@forgeglobal/forge-component-library';

interface DocumentsTableProps {
  documents: DocumentDto[];
}

export const TaxTable = ({ documents }: DocumentsTableProps) => {
  const { classes } = useStyles();
  const theme = useTheme();

  type DocumentRow = DocumentDto & { id: string };

  const rows: GridRowsProp<DocumentRow> = documents.map((d) => ({
    ...d,
    id: d.DocumentId ?? '',
  }));

  const columns: TypeSafeColDef<DocumentRow>[] = [
    { field: 'Period', headerName: 'Year' },
    {
      field: 'FundCode',
      headerName: 'Fund name',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'FundIssuerName',
      headerName: 'Issuer name',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'actions',
      headerName: 'Download',
      type: 'actions',
      getActions: (rowParams: GridRowParams<DocumentRow>) => {
        const url = `${
          getConfig().API_BASE_URL
        }/documents/download/${rowParams.row.DocumentId}`;
        return [
          <AuthenticatedLink
            title="Download..."
            url={url}
            fileName={rowParams.row?.FileName}
            className={classes.downloadLink}
            defaultFileName={'k1.pdf'}
            openInNewTab={false}>
            <Icons.Download className={classes.downloadIcon} />
          </AuthenticatedLink>,
        ];
      },
    },
  ];

  return (
    <div data-test-id="documents-table">
      <Table
        sx={{ padding: 0, borderRight: 'none', borderBottom: 'none' }}
        dataGridProps={{
          sx: {
            paddingTop: 0,
            backgroundColor: theme.palette.background.paper,
          },
          columns: columns,
          rows: rows,
          hideFooter: true,
        }}
      />
    </div>
  );
};
